import React from "react";
import makeStyles from '@mui/styles/makeStyles';
import { Switch, Route, useRouteMatch } from "react-router-dom";
import AfterLoginNavbar from "components/Navbars/AfterLoginNavbar";

import swal from "sweetalert";
import Notification from "../../../services/Notification";
import {checkLogin, checkUserPermission,getUserActionPermission} from "../../../services/CheckUserAccess";

//Role screen
import ExternalAPIDataTransferLog from "./ExternalAPIDataTransferLog";


const Index = (props) => {
  const classes = useStyles();
  const { path } = useRouteMatch();

  const menukey = "external-api-data-transfer-log";

  const [RedirectLogin, setRedirectLogin] = React.useState(true);
/*   const checkLogin = () => {  
    let token = sessionStorage.getItem("token");
    if (!token) {
      swal({
        title: "Oops!",
        text: 'token expired. Please login again',
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) { 
          window.location.href = process.env.REACT_APP_BASE_NAME+`/login`;
          sessionStorage.clear();
        }
      });
    }
  }; */
  
  const [hasUserPermission, setHasUserPermission] = React.useState(false);

  if(RedirectLogin){
    setHasUserPermission(checkUserPermission(menukey));// To check user has permission in this page
    checkLogin();
    setRedirectLogin(false);
  }


  React.useEffect(() => {
    // checkLogin();
    // checkAccess();
  }, []);


  const [msgObj, setMsgObj] = React.useState({
    isOpen: false,
  });
  const openNoticeModal = (obj) => {
    setMsgObj(obj);
  };
  const closeNoticeModal = (event, reason) => { 
      if (reason === 'clickaway') {
        return;
      } 
    setMsgObj({ isOpen: false });
  };

 

  

  return (
    hasUserPermission && (
    <div>
<AfterLoginNavbar {...props} />
<div
  className={`section signup-top-padding ${classes.dispenserContainer}`}
>
  <Switch>

    <Route
      path={`${path}/`}
      render={(props) => (
        <ExternalAPIDataTransferLog {...props} openNoticeModal={openNoticeModal} />
      )}
    ></Route>
    
  </Switch>
  <Notification
    closeNoticeModal={closeNoticeModal}
    msgObj={msgObj}
    {...props}
  ></Notification>
</div>
</div>)

  );
};



export default Index;

const useStyles = makeStyles({
  dispenserContainer: {
    backgroundImage: "url(" + require("assets/img/bg8.jpg") + ")",
    backgroundSize: "cover",
    backgroundPosition: "top center",
    minHeight: "753px",
  },
});
